import { Stand } from '../types/stand.types';

export const standsData: Stand[] = [
  // Espacios verdes
  { id: 'ev1', name: 'ESPACIO VERDE', category: 'espacio-verde', available: false, isSelectable: false, className: 'ev1' },
  { id: 'ev2', name: 'ESPACIO VERDE', category: 'espacio-verde', available: false, isSelectable: false, className: 'ev2' },
  { id: 'ev3', name: 'ESPACIO VERDE', category: 'espacio-verde', available: false, isSelectable: false, className: 'ev3' },

  // Stands exteriores
  { id: 'exA', name: 'STANDS EXTERIORES A', category: 'exterior', price: 3000, available: true, isSelectable: true, className: 'exA' },
  { id: 'exB', name: 'STANDS EXTERIORES B', category: 'exterior', price: 3000, available: true, isSelectable: true, className: 'exB' },
  { id: 'exC', name: 'STANDS EXTERIORES C', category: 'exterior', price: 3000, available: true, isSelectable: true, className: 'exC' },

  // Food trucks
  { id: 'food', name: 'SECTOR FOOD TRUCKS', category: 'food', available: false, isSelectable: false, className: 'food' },

  // Fila 1 - Stands naranjas (P1-P10)
  ...Array.from({ length: 10 }, (_, i) => ({
    id: `${i + 1}`,
    name: `P${i + 1}`,
    category: 'orange' as const,
    price: 2500,
    size: '5m²',
    available: true,
    isSelectable: true,
    className: 'fila1-item'
  })),

  // Salas
  { id: 'sala1', name: 'SALA 1', category: 'sala', available: false, isSelectable: false, className: 'sala1' },
  { id: 'sala2', name: 'SALA 2', category: 'sala', available: false, isSelectable: false, className: 'sala2' },

  // Plazas
  { id: 'plaza-auto1', name: 'C1', category: 'plaza', price: 5000, size: '40m²', available: true, isSelectable: true, className: 'plaza-auto1' },
  { id: 'plaza-auto2', name: 'C11', category: 'plaza', price: 5000, size: '40m²', available: true, isSelectable: true, className: 'plaza-auto2' },
  { id: 'plaza-innovacion1', name: 'C21', category: 'plaza', price: 5000, size: '38.5m²', available: true, isSelectable: true, className: 'plaza-innovacion1' },
  // 4 stands a la derecha de C1 (primer cuadrado)
  { id: 'stand-c1-1', name: 'C2', category: 'orange', price: 2500, size: '10m²', available: true, isSelectable: true, className: 'stand-c1-1' },
  { id: 'stand-c1-2', name: 'C3', category: 'orange', price: 2500, size: '10m²', available: true, isSelectable: true, className: 'stand-c1-2' },
  { id: 'stand-c1-3', name: 'C6', category: 'orange', price: 2500, size: '10m²', available: true, isSelectable: true, className: 'stand-c1-3' },
  { id: 'stand-c1-4', name: 'C7', category: 'orange', price: 2500, size: '10m²', available: true, isSelectable: true, className: 'stand-c1-4' },
  // 4 stands al lado del primer cuadrado (segundo cuadrado)
  { id: 'stand-c1-5', name: 'C4', category: 'orange', price: 2500, size: '10m²', available: true, isSelectable: true, className: 'stand-c1-5' },
  { id: 'stand-c1-6', name: 'C5', category: 'orange', price: 2500, size: '10m²', available: true, isSelectable: true, className: 'stand-c1-6' },
  { id: 'stand-c1-7', name: 'C8', category: 'orange', price: 2500, size: '10m²', available: true, isSelectable: true, className: 'stand-c1-7' },
  { id: 'stand-c1-8', name: 'C9', category: 'orange', price: 2500, size: '10m²', available: true, isSelectable: true, className: 'stand-c1-8' },
  // Stand alto a la derecha de los dos cuadrados
  { id: 'stand-c1-alto', name: 'C10', category: 'orange', price: 2500, size: '20m²', available: true, isSelectable: true, className: 'stand-c1-alto' },
  // Dos stands alineados con el primer cuadro-4-stands (en la fila de C21)
  { id: 'stand-c21-1', name: 'C22', category: 'orange', price: 2500, size: '40m²', available: true, isSelectable: true, className: 'stand-c21-1' },
  { id: 'stand-c21-2', name: 'C23', category: 'orange', price: 2500, size: '60m²', available: true, isSelectable: true, className: 'stand-c21-2' },
  // 4 stands del primer cuadrado debajo de C21
  { id: 'stand-c21-c1-1', name: 'C12', category: 'orange', price: 2500, size: '10m²', available: true, isSelectable: true, className: 'stand-c21-c1-1' },
  { id: 'stand-c21-c1-2', name: 'C13', category: 'orange', price: 2500, size: '10m²', available: true, isSelectable: true, className: 'stand-c21-c1-2' },
  { id: 'stand-c21-c1-3', name: 'C16', category: 'orange', price: 2500, size: '10m²', available: true, isSelectable: true, className: 'stand-c21-c1-3' },
  { id: 'stand-c21-c1-4', name: 'C17', category: 'orange', price: 2500, size: '10m²', available: true, isSelectable: true, className: 'stand-c21-c1-4' },
  // 4 stands del segundo cuadrado debajo de C21
  { id: 'stand-c21-c1-5', name: 'C14', category: 'orange', price: 2500, size: '10m²', available: true, isSelectable: true, className: 'stand-c21-c1-5' },
  { id: 'stand-c21-c1-6', name: 'C15', category: 'orange', price: 2500, size: '10m²', available: true, isSelectable: true, className: 'stand-c21-c1-6' },
  { id: 'stand-c21-c1-7', name: 'C18', category: 'orange', price: 2500, size: '10m²', available: true, isSelectable: true, className: 'stand-c21-c1-7' },
  { id: 'stand-c21-c1-8', name: 'C19', category: 'orange', price: 2500, size: '10m²', available: true, isSelectable: true, className: 'stand-c21-c1-8' },
  // Stand alto debajo de C21
  { id: 'stand-c21-alto', name: 'C20', category: 'orange', price: 2500, size: '20m²', available: true, isSelectable: true, className: 'stand-c21-alto' },

  // Stands individuales (el stand 9 ahora es naranja en fila1, así que eliminamos este)

  // Fila 3 - Stands naranjas (P11-P20)
  ...Array.from({ length: 10 }, (_, i) => ({
    id: `${i + 35}`,
    name: `P${i + 11}`,
    category: 'orange' as const,
    price: 2500,
    size: '5m²',
    available: true,
    isSelectable: true,
    className: 'fila3-item'
  })),

  // Sala principal
  { id: 'sala-principal', name: 'SALA PRINCIPAL', category: 'principal', available: false, isSelectable: false, className: 'sala-principal' },

  // Sala VIP
  { id: 'sala-vip', name: 'SALA VIP', category: 'vip', available: false, isSelectable: false, className: 'sala-vip' }
];

// Estructura de cargos por tipo de organización (área ahora es independiente)
export const cargosYAreasPorTipo = {
  'Empresa': {
    cargos: [
      'Director General (CEO)',
      'Presidente',
      'Vicepresidente',
      'Miembro del Directorio',
      'Director de Área',
      'Gerente de Área',
      'Jefe de Área',
      'Coordinador',
      'Asesor',
      'Apoderado',
      'Asistente',
      'Otro'
    ]
  },
  'StartUp': {
    cargos: [
      'Fundador',
      'Cofundador',
      'Director General (CEO)',
      'Presidente',
      'Miembro del Directorio / Advisory',
      'Director de Área',
      'Gerente de Área',
      'Jefe de Área',
      'Coordinador',
      'Asesor',
      'Asistente',
      'Otro'
    ]
  },
  'Agencia': {
    cargos: [
      'Socio Director',
      'Director General',
      'Miembro del Directorio',
      'Director de Área',
      'Gerente de Área',
      'Jefe de Área',
      'Coordinador',
      'Productor Ejecutivo',
      'Asesor',
      'Representante Comercial',
      'Asistente',
      'Otro'
    ]
  },
  'Medio de Comunicación': {
    cargos: [
      'Director General',
      'Director',
      'Editor General',
      'Productor Ejecutivo',
      'Miembro del Directorio',
      'Director de Área',
      'Gerente de Área',
      'Jefe de Área',
      'Coordinador',
      'Asesor',
      'Asistente',
      'Otro'
    ]
  },
  'Cámara Empresarial': {
    cargos: [
      'Presidente',
      'Vicepresidente',
      'Secretario General',
      'Tesorero',
      'Director Ejecutivo',
      'Vocal del Consejo Directivo',
      'Director de Área',
      'Coordinador',
      'Asesor',
      'Representante Sectorial',
      'Asistente',
      'Otro'
    ]
  },
  'Asociación Profesional': {
    cargos: [
      'Presidente',
      'Vicepresidente',
      'Secretario General',
      'Tesorero',
      'Director Ejecutivo',
      'Vocal del Consejo Directivo',
      'Director de Área',
      'Coordinador',
      'Asesor',
      'Representante Institucional',
      'Asistente',
      'Otro'
    ]
  },
  'Embajada': {
    cargos: [
      'Embajador',
      'Ministro Consejero (Jefe de Misión Adjunto)',
      'Consejero',
      'Primer Secretario',
      'Segundo Secretario',
      'Agregado',
      'Cónsul General',
      'Cónsul',
      'Coordinador',
      'Asesor',
      'Asistente',
      'Otro'
    ]
  },
  'Cámara Bilateral': {
    cargos: [
      'Presidente',
      'Vicepresidente',
      'Secretario General',
      'Tesorero',
      'Director Ejecutivo',
      'Vocal del Consejo Directivo',
      'Director de Área',
      'Coordinador',
      'Asesor',
      'Representante País/Región',
      'Asistente',
      'Otro'
    ]
  },
  'Asociación Civil': {
    cargos: [
      'Presidente',
      'Vicepresidente',
      'Secretario',
      'Tesorero',
      'Director Ejecutivo',
      'Miembro del Consejo Directivo',
      'Director de Área',
      'Coordinador',
      'Asesor',
      'Responsable de Proyectos',
      'Asistente',
      'Otro'
    ]
  },
  'Universidad': {
    cargos: [
      'Rector',
      'Vicerrector',
      'Secretario General',
      'Decano',
      'Vicedecano',
      'Director de Instituto/Escuela',
      'Director de Área',
      'Profesor Titular',
      'Investigador Principal',
      'Coordinador',
      'Asistente',
      'Otro'
    ]
  },
  'Fundación': {
    cargos: [
      'Presidente',
      'Vicepresidente',
      'Director Ejecutivo',
      'Secretario',
      'Tesorero',
      'Miembro del Consejo de Administración',
      'Director de Área',
      'Coordinador',
      'Asesor',
      'Responsable de Programas',
      'Asistente',
      'Otro'
    ]
  },
  'Institución Académica': {
    cargos: [
      'Director General',
      'Vicedirector',
      'Secretario',
      'Miembro del Consejo Académico',
      'Director de Área',
      'Jefe de Área',
      'Coordinador',
      'Profesor Titular',
      'Investigador Responsable',
      'Asesor',
      'Asistente',
      'Otro'
    ]
  },
  'Organización sin fines de lucro': {
    cargos: [
      'Presidente',
      'Vicepresidente',
      'Secretario',
      'Tesorero',
      'Director Ejecutivo',
      'Miembro del Consejo Directivo',
      'Director de Área',
      'Coordinador',
      'Asesor',
      'Responsable de Alianzas',
      'Asistente',
      'Otro'
    ]
  },
  'Organismo Internacional': {
    cargos: [
      'Representante Residente',
      'Director de País',
      'Jefe de Misión',
      'Oficial Superior',
      'Director Ejecutivo',
      'Miembro del Board',
      'Director de Área',
      'Coordinador',
      'Asesor',
      'Enlace',
      'Asistente',
      'Otro'
    ]
  },
  'Asociación Gubernamental': {
    cargos: [
      'Presidente',
      'Vicepresidente',
      'Secretario General',
      'Director Ejecutivo',
      'Miembro del Consejo',
      'Director de Área',
      'Coordinador',
      'Asesor',
      'Jefe de Unidad',
      'Representante Oficial',
      'Asistente',
      'Otro'
    ]
  },
  'Gobierno Nacional o Provincial': {
    cargos: [
      'Ministro',
      'Secretario',
      'Subsecretario',
      'Jefe de Gabinete',
      'Titular de Organismo/Agencia',
      'Director Nacional/Provincial',
      'Director General',
      'Director de Área',
      'Coordinador',
      'Asesor',
      'Asistente',
      'Otro'
    ]
  },
  'Gobierno Municipal': {
    cargos: [
      'Intendente/Alcalde',
      'Jefe de Gabinete',
      'Secretario',
      'Subsecretario',
      'Director General',
      'Director de Área',
      'Jefe de Área',
      'Coordinador',
      'Concejal',
      'Asesor',
      'Asistente',
      'Otro'
    ]
  },
  'Sector Público (ente o institución)': {
    cargos: [
      'Presidente del Ente',
      'Vicepresidente',
      'Director Ejecutivo',
      'Gerente General',
      'Director General',
      'Director de Área',
      'Jefe de Área',
      'Coordinador',
      'Asesor',
      'Interventor',
      'Asistente',
      'Otro'
    ]
  }
};

// Mantener las listas originales para compatibilidad (se pueden eliminar después)
export const cargos = [
  'CEO/Director General',
  'Gerente',
  'Coordinador',
  'Analista',
  'Desarrollador',
  'Diseñador',
  'Marketing',
  'Ventas',
  'Recursos Humanos',
  'Otro'
];

export const areas = [
  'Dirección y Gobierno Corporativo',
  'Administración y Finanzas',
  'Recursos Humanos / Talento',
  'Operaciones',
  'Tecnología e Innovación',
  'Marketing, Comunicación y Ventas',
  'Desarrollo de Negocios y Estrategia',
  'Productos y Servicios',
  'Sostenibilidad y Responsabilidad Social',
  'Seguridad, Riesgo y Cumplimiento',
  'Asuntos Públicos y Relacionamiento Externo'
];

// Subáreas organizadas por área
export const subareasPorArea = {
  'Dirección y Gobierno Corporativo': {
    subareas: [
      'Dirección General / CEO',
      'Presidencia',
      'Vicepresidencia',
      'Secretaría de Directorio',
      'Gobierno Corporativo',
      'Auditoría Interna',
      'Gestión de Riesgos',
      'Asuntos Legales / Jurídicos',
      'Compliance y Ética',
      'Relaciones Institucionales'
    ]
  },
  'Administración y Finanzas': {
    subareas: [
      'Administración General',
      'Contabilidad',
      'Finanzas',
      'Control de Gestión',
      'Tesorería',
      'Impuestos',
      'Compras y Contrataciones',
      'Gestión de Proveedores',
      'Auditoría Financiera',
      'Presupuesto y Planeamiento'
    ]
  },
  'Recursos Humanos / Talento': {
    subareas: [
      'Desarrollo de Talento',
      'Selección y Reclutamiento',
      'Capacitación y Formación',
      'Evaluaciones de Desempeño',
      'Compensaciones y Beneficios',
      'Cultura Organizacional',
      'Diversidad, Equidad e Inclusión',
      'Relaciones Laborales',
      'Clima Organizacional',
      'Bienestar y Salud Ocupacional'
    ]
  },
  'Operaciones': {
    subareas: [
      'Operaciones Generales',
      'Logística',
      'Supply Chain',
      'Gestión de Calidad',
      'Gestión de Procesos',
      'Mantenimiento',
      'Servicios Generales',
      'Producción / Planta',
      'Seguridad e Higiene',
      'Operaciones Técnicas'
    ]
  },
  'Tecnología e Innovación': {
    subareas: [
      'Sistemas / TI',
      'Infraestructura Tecnológica',
      'Desarrollo de Software',
      'Soporte Técnico',
      'Ciberseguridad',
      'Arquitectura de Datos',
      'Big Data & Analytics',
      'Inteligencia Artificial',
      'Innovación y Transformación Digital',
      'Automatización y Robótica',
      'UX/UI y Productos Digitales'
    ]
  },
  'Marketing, Comunicación y Ventas': {
    subareas: [
      'Marketing',
      'Comunicación Institucional',
      'Comunicación Interna',
      'Branding',
      'Publicidad',
      'Ventas',
      'Atención al Cliente',
      'Experiencia de Usuario / Customer Success',
      'Relaciones Públicas',
      'Eventos Corporativos',
      'Investigación de Mercados',
      'Marketing Digital & Performance'
    ]
  },
  'Desarrollo de Negocios y Estrategia': {
    subareas: [
      'Planeamiento Estratégico',
      'Nuevos Negocios',
      'Desarrollo Corporativo',
      'Innovación Empresarial',
      'Alianzas y Partnerships',
      'Gestión de Proyectos',
      'Inteligencia Competitiva',
      'Expansión Internacional'
    ]
  },
  'Productos y Servicios': {
    subareas: [
      'Gestión de Producto',
      'Desarrollo de Servicios',
      'Investigación & Desarrollo (I+D)',
      'Laboratorios',
      'Gestión de Portafolio',
      'Experiencia del Usuario'
    ]
  },
  'Sostenibilidad y Responsabilidad Social': {
    subareas: [
      'Sostenibilidad Ambiental',
      'Economía Circular',
      'Energía y Transición Verde',
      'Responsabilidad Social Empresaria (RSE)',
      'Gestión de Impacto',
      'Reportes ESG'
    ]
  },
  'Seguridad, Riesgo y Cumplimiento': {
    subareas: [
      'Seguridad Física',
      'Seguridad Informática',
      'Gestión de Riesgos',
      'Crisis y Continuidad Operativa',
      'Compliance',
      'Asuntos Regulatorios'
    ]
  },
  'Asuntos Públicos y Relacionamiento Externo': {
    subareas: [
      'Relaciones Gubernamentales',
      'Relaciones con la Comunidad',
      'Vinculación Académica',
      'Relaciones Internacionales',
      'Gestión de Stakeholders'
    ]
  }
};

export const tiposOrganizacion = [
  'Empresa / PyME',
  'Startup / Emprendimiento',
  'Agencia / Consultora',
  'Cámara Empresarial / Sectorial',
  'Cámara de Comercio Binacional',
  'Asociación Profesional',
  'ONG / Fundación / Asociación Civil',
  'Universidad / Institución Educativa',
  'Centro Tecnológico / I+D',
  'Institución de Salud / Deportiva / Cultural / Turismo / Otra',
  'Gobierno Nacional / Provincial',
  'Gobierno Municipal',
  'Ente o Institución del Sector Público',
  'Organismo Internacional',
  'Embajada',
  'Inversionista / Aceleradora',
  'Medio de Comunicación',
  'Proveedor de Soluciones Tecnológicas'
];

export const organizaciones = [
  'Google', 'Microsoft', 'Apple', 'Amazon', 'Meta (Facebook)', 'Tesla', 'Netflix', 'Spotify',
  'Uber', 'Airbnb', 'Salesforce', 'Adobe', 'Oracle', 'IBM', 'Intel', 'Cisco', 'Dell', 'HP',
  'NVIDIA', 'AMD', 'Samsung', 'Sony', 'Panasonic', 'LG', 'Huawei', 'Xiaomi', 'Alibaba',
  'Tencent', 'Baidu', 'ByteDance', 'OpenAI', 'Anthropic', 'Stripe', 'Square', 'PayPal',
  'Visa', 'Mastercard', 'American Express', 'JPMorgan Chase', 'Bank of America', 'Wells Fargo',
  'Goldman Sachs', 'Morgan Stanley', 'BlackRock', 'Vanguard', 'Berkshire Hathaway',
  'Johnson & Johnson', 'Procter & Gamble', 'Coca-Cola', 'PepsiCo', 'Nestlé', 'Unilever',
  'General Electric', 'General Motors', 'Ford', 'Toyota', 'Volkswagen', 'BMW', 'Mercedes-Benz',
  'Audi', 'Honda', 'Nissan', 'Hyundai', 'Kia', 'Ferrari', 'Porsche', 'Lamborghini'
];

export const industrias = [
  'Agroindustria, Producción de Alimentos y Bioeconomía',
  'Alimentación, Nutrición y Sistemas Alimentarios Urbanos',
  'Agua, Saneamiento y Recursos Hídricos',
  'Energía, Recursos Naturales y Transición Energética',
  'Construcción, Infraestructura y Desarrollo Urbano',
  'Arquitectura, Diseño Urbano y Construcción Sostenible',
  'Movilidad, Transporte y Logística Inteligente',
  'Tecnología, Innovación y Transformación Digital',
  'Inteligencia Artificial y Tecnologías Avanzadas',
  'Ciberseguridad y Protección de Datos',
  'Electrónica, Automatización y Robótica',
  'Manufactura, Industria 4.0 y Producción Avanzada',
  'Minería, Materiales y Recursos Naturales',
  'Economía Circular y Gestión de Residuos',
  'Medio Ambiente y Cambio Climático',
  'Salud, Medicina y Ciencias de la Vida',
  'Deporte, Ciencias del Deporte y Bienestar',
  'Educación, Formación y EdTech',
  'Cultura, Industrias Creativas y Economía Naranja',
  'Turismo, Hotelería y Gastronomía',
  'Comercio, Retail y Comercio Electrónico',
  'Finanzas, Banca, Seguros y Fintech',
  'Telecomunicaciones y Conectividad',
  'Economía Social, Cooperativas y Desarrollo Comunitario',
  'Gobierno, Políticas Públicas y Smart Governance',
  'Seguridad, Emergencias y Resiliencia Urbana',
  'Inmobiliario, Real Estate y PropTech',
  'Recursos Humanos, Talento y Desarrollo Profesional',
  'Legal, Contable y Servicios Profesionales',
  'Industrias Textil, Moda y Sostenibilidad',
  'Industria Farmacéutica y Laboratorios',
  'Nanotecnología y Ciencia de Materiales',
  'Aeronáutica, Aeroespacial y Drones',
  'Servicios Empresariales y Consultoría',
  'Industrias Creativas Digitales y Medios'
];

// Subindustrias organizadas por industria
export const subindustriasPorIndustria = {
  'Agroindustria, Producción de Alimentos y Bioeconomía': {
    subindustrias: [
      'AgTech',
      'Ganadería',
      'Producción Agroalimentaria',
      'Bioinsumos',
      'Trazabilidad'
    ]
  },
  'Alimentación, Nutrición y Sistemas Alimentarios Urbanos': {
    subindustrias: [
      'Foodtech',
      'Nutrición',
      'Seguridad Alimentaria',
      'Cadenas de Valor Alimentarias'
    ]
  },
  'Agua, Saneamiento y Recursos Hídricos': {
    subindustrias: [
      'Tratamiento de Agua',
      'Saneamiento',
      'Infraestructura Hídrica',
      'Monitoreo'
    ]
  },
  'Energía, Recursos Naturales y Transición Energética': {
    subindustrias: [
      'Energías Renovables',
      'Oil & Gas',
      'Redes Inteligentes',
      'Almacenamiento Energético'
    ]
  },
  'Construcción, Infraestructura y Desarrollo Urbano': {
    subindustrias: [
      'Obras Públicas',
      'Construcción Privada',
      'Materiales',
      'Infraestructura Urbana'
    ]
  },
  'Arquitectura, Diseño Urbano y Construcción Sostenible': {
    subindustrias: [
      'Diseño Urbano',
      'Arquitectura Sustentable',
      'Certificaciones Ambientales'
    ]
  },
  'Movilidad, Transporte y Logística Inteligente': {
    subindustrias: [
      'Movilidad Eléctrica',
      'Transporte Público',
      'ITS',
      'Logistica 4.0'
    ]
  },
  'Tecnología, Innovación y Transformación Digital': {
    subindustrias: [
      'Cloud',
      'IoT',
      'Software',
      'Hardware'
    ]
  },
  'Inteligencia Artificial y Tecnologías Avanzadas': {
    subindustrias: [
      'AI',
      'Machine Learning',
      'Deep Learning',
      'Automatización Inteligente'
    ]
  },
  'Ciberseguridad y Protección de Datos': {
    subindustrias: [
      'Ciberseguridad',
      'Gestión de Identidad',
      'Protección de Datos'
    ]
  },
  'Electrónica, Automatización y Robótica': {
    subindustrias: [
      'Robótica',
      'Automatización Industrial',
      'Sensores'
    ]
  },
  'Manufactura, Industria 4.0 y Producción Avanzada': {
    subindustrias: [
      'Fábricas Inteligentes',
      'Impresión 3D',
      'Ingeniería de Procesos'
    ]
  },
  'Minería, Materiales y Recursos Naturales': {
    subindustrias: [
      'Minería Sostenible',
      'Procesamiento de Minerales',
      'Nuevos Materiales'
    ]
  },
  'Economía Circular y Gestión de Residuos': {
    subindustrias: [
      'Reciclaje',
      'Gestión de Residuos',
      'Valorización'
    ]
  },
  'Medio Ambiente y Cambio Climático': {
    subindustrias: [
      'Mitigación',
      'Adaptación',
      'Monitoreo Ambiental'
    ]
  },
  'Salud, Medicina y Ciencias de la Vida': {
    subindustrias: [
      'Hospitales',
      'Salud Digital',
      'Biotech',
      'Equipamiento Médico'
    ]
  },
  'Deporte, Ciencias del Deporte y Bienestar': {
    subindustrias: [
      'Clubes',
      'Fitness',
      'eSports',
      'Tecnología Deportiva'
    ]
  },
  'Educación, Formación y EdTech': {
    subindustrias: [
      'Instituciones Educativas',
      'EdTech',
      'Capacitación'
    ]
  },
  'Cultura, Industrias Creativas y Economía Naranja': {
    subindustrias: [
      'Audiovisual',
      'Videojuegos',
      'Música',
      'Diseño'
    ]
  },
  'Turismo, Hotelería y Gastronomía': {
    subindustrias: [
      'Hotelería',
      'Gastronomía',
      'Turismo Inteligente'
    ]
  },
  'Comercio, Retail y Comercio Electrónico': {
    subindustrias: [
      'RetailTech',
      'E-commerce',
      'Centros Comerciales'
    ]
  },
  'Finanzas, Banca, Seguros y Fintech': {
    subindustrias: [
      'Fintech',
      'Seguros',
      'Banca Digital'
    ]
  },
  'Telecomunicaciones y Conectividad': {
    subindustrias: [
      '5G',
      'Fibra Óptica',
      'Satélites',
      'Proveedores de Internet'
    ]
  },
  'Economía Social, Cooperativas y Desarrollo Comunitario': {
    subindustrias: [
      'Cooperativas',
      'ONGs',
      'Desarrollo Social'
    ]
  },
  'Gobierno, Políticas Públicas y Smart Governance': {
    subindustrias: [
      'Gobierno Digital',
      'Datos Abiertos',
      'Servicios Públicos'
    ]
  },
  'Seguridad, Emergencias y Resiliencia Urbana': {
    subindustrias: [
      'Seguridad Ciudadana',
      'Bomberos',
      'Emergencias Médicas',
      'Defensa Civil'
    ]
  },
  'Inmobiliario, Real Estate y PropTech': {
    subindustrias: [
      'Desarrollos Inmobiliarios',
      'PropTech',
      'Gestión de Activos'
    ]
  },
  'Recursos Humanos, Talento y Desarrollo Profesional': {
    subindustrias: [
      'Consultoras RRHH',
      'Capacitación Ejecutiva',
      'Reclutamiento'
    ]
  },
  'Legal, Contable y Servicios Profesionales': {
    subindustrias: [
      'Estudios Jurídicos',
      'Estudios Contables',
      'Asesorias'
    ]
  },
  'Industrias Textil, Moda y Sostenibilidad': {
    subindustrias: [
      'Moda Sostenible',
      'Producción Textil',
      'Innovación Textil'
    ]
  },
  'Industria Farmacéutica y Laboratorios': {
    subindustrias: [
      'Laboratorios',
      'Investigación Clínica',
      'Desarrollo Farmacéutico'
    ]
  },
  'Nanotecnología y Ciencia de Materiales': {
    subindustrias: [
      'Nanomateriales',
      'Laboratorios',
      'Aplicaciones Industriales'
    ]
  },
  'Aeronáutica, Aeroespacial y Drones': {
    subindustrias: [
      'Drones',
      'Aeronáutica',
      'Aeroespacial'
    ]
  },
  'Servicios Empresariales y Consultoría': {
    subindustrias: [
      'Consultorías',
      'Auditoría',
      'Servicios BPO'
    ]
  },
  'Industrias Creativas Digitales y Medios': {
    subindustrias: [
      'Agencias Digitales',
      'Medios',
      'Publicidad'
    ]
  }
};